import { useTranslation } from 'react-i18next';
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';
import { SDRM, sdrmCls } from './responseModal.classes';

export const ResponseModal = ({ responseData, setResponseData, isOpen, setIsOpen }: any) => {
    const { t } = useTranslation();

    const handleClose = () => {
        setIsOpen(false);
        setResponseData();
    };

    return (
        <Dialog className={SDRM.dialog} open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle className={SDRM.title}>
                <Box className={SDRM.titleLayout} sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', width: '100%' }}>
                    <p className={SDRM.titleText} style={{ fontSize: '16px', fontWeight: '600' }}>
                        {t('scheduleService.responseDetail')}
                    </p>
                    <IconButton className={SDRM.closeButton} sx={{ marginLeft: 'auto' }}>
                        <CloseIcon className={['svg_icons', SDRM.closeIcon].filter(Boolean).join(' ')} onClick={handleClose} />
                    </IconButton>
                </Box>
            </DialogTitle>
            <DialogContent className={SDRM.content}>
                <Box className={SDRM.body} sx={{ overflow: 'auto', padding: '24px' }}>
                    <Box
                        className={sdrmCls(SDRM.row, SDRM.rowStatus)}
                        sx={{ display: 'flex', flexDirection: 'row', marginBottom: '8px', alignItems: 'center' }}
                    >
                        <p className={SDRM.rowLabel} style={{ fontSize: '14px', fontWeight: '600', marginRight: '8px' }}>
                            {t('scheduleService.responseStatus')}:
                        </p>
                        <p className={SDRM.rowValue} style={{ fontSize: '14px', fontWeight: '400' }}>
                            {responseData?.responseStatus}
                        </p>
                    </Box>
                    <Box
                        className={sdrmCls(SDRM.row, SDRM.rowCode)}
                        sx={{ display: 'flex', flexDirection: 'row', marginBottom: '8px', alignItems: 'center' }}
                    >
                        <p className={SDRM.rowLabel} style={{ fontSize: '14px', fontWeight: '600', marginRight: '8px' }}>
                            {t('scheduleService.responseCode')}:
                        </p>
                        <p className={SDRM.rowValue} style={{ fontSize: '14px', fontWeight: '400' }}>
                            {responseData?.responseStatusCode}
                        </p>
                    </Box>
                    <Box
                        className={sdrmCls(SDRM.row, SDRM.rowBody)}
                        sx={{ display: 'flex', flexDirection: 'row', marginBottom: '8px', alignItems: 'center' }}
                    >
                        <p className={SDRM.rowLabel} style={{ fontSize: '14px', fontWeight: '600', marginRight: '8px' }}>
                            {t('scheduleService.responseBody')}:
                        </p>
                        <p className={SDRM.rowValue} style={{ fontSize: '14px', fontWeight: '400' }}>
                            {responseData?.responseBody}
                        </p>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>
    );
};
